enum DateInputType {
  FULL = 'FULL',
  MONTH = 'MONTH'
}

export default DateInputType;
